import { QueryClientMiddlewareContext } from "@/components/QueryClientProvider";
import { useContext } from "react";

export const useQueryClientMiddleware = () => {
    const context = useContext(QueryClientMiddlewareContext);
    if (!context) {
        throw new Error("useQueryClientMiddleware must be used within QueryClientProvider");
    }

    return context;
};
